import { render, staticRenderFns } from "./CouponVipPopup.vue?vue&type=template&id=667c84d4&"
import script from "./CouponVipPopup.vue?vue&type=script&lang=js&"
export * from "./CouponVipPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports